import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

const Graph2 = () => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });

  useEffect(() => {
    fetch(`${API}/graph2`)
      .then(res => res.json())
      .then(data => {
        const moisLabels = [
          'Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin',
          'Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'
        ];

        const receptionFaites = Array(12).fill(null);
        const receptionAVenir = Array(12).fill(null);

        data.forEach(item => {
          const index = item.Mois - 1;
          receptionFaites[index] = item["Réception faites"] === 0 ? null : item["Réception faites"];
          receptionAVenir[index] = item["Réception à venir"] === 0 ? null : item["Réception à venir"];
        });

        setChartData({
          labels: moisLabels,
          datasets: [
            {
              label: 'Réceptions faites',
              data: receptionFaites,
              backgroundColor: 'rgba(187, 241, 192, 0.75)',
              borderWidth: 0,
              borderRadius: 4,
              stack: 'stack1',
            },
            {
              label: 'Réceptions à venir',
              data: receptionAVenir,
              backgroundColor: 'rgba(56, 189, 248, 0.65)',
              borderWidth: 0,
              borderRadius: 4,
              stack: 'stack1',
            }
          ]
        });
      })
      .catch(err => console.error('Erreur récupération Graph2 :', err));
  }, []);

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'RÉCEPTIONS FOURNISSEURS',
        color: '#04202d',
        font: { family: "'IBM Plex Mono', monospace", size: 20, weight: '500' },
        padding: { bottom: 16 },
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: '#ffffff',
        borderColor: '#f0ece2',
        borderWidth: 0,
        titleColor: '#04202d',
        bodyColor: '#8b7b64',
        titleFont: { family: "'IBM Plex Mono', monospace", size: 20 },
        bodyFont: { family: "'IBM Plex Sans', sans-serif", size: 20 },
        padding: 10,
      },
      legend: {
        position: 'bottom',
        labels: {
          color: '#8b7b64',
          font: { family: "'IBM Plex Sans', sans-serif", size: 20 },
          boxWidth: 12,
          boxHeight: 12,
          padding: 16,
        }
      }
    },
    scales: {
      x: {
        stacked: true,
        grid: { color: '#f5f1eb', drawBorder: false },
        ticks: {
          color: '#8b7b64',
          font: { family: "'IBM Plex Mono', monospace", size: 10 },
          autoSkip: false,
          maxRotation: 0,
          minRotation: 0,
        },
        border: { color: '#f0ece2' },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        grid: { color: '#f5f1eb', drawBorder: false },
        ticks: {
          color: '#8b7b64',
          font: { family: "'IBM Plex Mono', monospace", size: 10 },
          stepSize: 50,
        },
        border: { color: '#f0ece2' },
      }
    }
  };

  return (
    <div style={{
      background: '#ffffff',
      border: '1px solid #f0ece2',
      borderRadius: '14px',
      padding: '20px 24px',
      boxShadow: '0 2px 12px rgba(148, 99, 46, 0.06)',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute',
        top: 0, left: 0, right: 0,
        height: '3px',
        borderRadius: '14px 14px 0 0',
      }} />
      <Bar data={chartData} options={options} height={400} width={800} />
    </div>
  );
};

export default Graph2;